import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue"
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue"
import Login from "@/pages/Login.vue"
//Dashboard
import Umsätze from "@/pages/dashboard/Umsätze.vue"
//Kalender
import Kalender from "@/pages/kalender/Kalender.vue"
import Addblocker from "@/pages/kalender/Addblocker.vue"
//LMS
import Kunden from "@/pages/lms/Kunden.vue"
import Tagestour from "@/pages/lms/Tagestour.vue"
import Informationen from "@/pages/lms/Informationen.vue"
import Information from "@/pages/lms/Information.vue"
import Pfandrückgabe from "@/pages/lms/Pfandrückgabe.vue"
import Warenrücknahme from "@/pages/lms/Warenrücknahme.vue"
import AddBestellung from "@/pages/lms/AddBestellung.vue"
import EditBestellung from "@/pages/lms/EditBestellung.vue"
import Bestellungsdetails from "@/pages/lms/Bestelldetails.vue"
import Packliste from "@/pages/lms/Packliste.vue"
import GoogleMap from "@/pages/lms/GoogleMap.vue"
//Checklisten
import ChecklistsDriverAdd from "@/pages/lms/checklist/AddChecklistDriver.vue"
import ChecklistsDriver from "@/pages/lms/checklist/ChecklistsDriver.vue"
import ChecklistDriver from "@/pages/lms/checklist/ChecklistDriver.vue"

// ----------------------------
// --- Qualitaetssicherung: ---
import DashboardQS from "@/pages/qualitaetssicherung/DashboardQS.vue"
import DashboardSL from "@/pages/qualitaetssicherung/servicelisten/DashboardSL.vue"
import DashboardCL from "@/pages/qualitaetssicherung/servicelisten/checklisten/DashboardCL.vue"
// Checklisten Reinigungsnachweise:
import DashboardRN from "@/pages/qualitaetssicherung/servicelisten/checklisten/reinigungsnachweise/DashboardRN.vue"
import ChecklistRN from "@/pages/qualitaetssicherung/servicelisten/checklisten/reinigungsnachweise/ChecklistRN.vue"
import AddChecklistRN from "@/pages/qualitaetssicherung/servicelisten/checklisten/reinigungsnachweise/AddChecklistRN.vue"
// Orgainvent:
import DashboardOI from "@/pages/qualitaetssicherung/servicelisten/orgainvent/DashboardOI.vue"
import AddOrgainvent from "@/pages/qualitaetssicherung/servicelisten/orgainvent/AddOrgainvent.vue"
//Heisse Theke:
import HTBereich from "@/pages/qualitaetssicherung/servicelisten/heissetheke/HTBereich.vue"
import AddHTTempLog from "@/pages/qualitaetssicherung/servicelisten/heissetheke/AddHTTempLog.vue"
//Temperatur Logging:
import Temperaturen from "@/pages/qualitaetssicherung/temperatur/TempBereiche.vue"
import AddLog from "@/pages/qualitaetssicherung/temperatur/AddLog.vue"
import TempLogs from "@/pages/qualitaetssicherung/temperatur/TempLogs.vue"
//Wareneingang:
import WEBereich from "@/pages/qualitaetssicherung/servicelisten/wareneingang/WEBereich.vue"
import AddWETempLog from "@/pages/qualitaetssicherung/servicelisten/wareneingang/AddWETempLog.vue"
// ----------------------------

const routes = [
    {
        path: "/",
        component: DashboardLayout,
        redirect: "/tagestour",
        children: [
            {
                path: "checklist/drivers/:id",
                name: "checklistdriver",
                component: ChecklistDriver,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "checklists/driver",
                name: "checklistsdriver",
                component: ChecklistsDriver,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "checklists/driver/add",
                name: "checklistsdriveradd",
                component: ChecklistsDriverAdd,
                meta: {
                    requiresAuth: true
                }
            },
            // ----------------------------
            // --- Qualitaetssicherung: ---
            {
                path: "qs",
                name: "qualitätssicherung",
                component: DashboardQS,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/servicelisten",
                name: "servicelisten",
                component: DashboardSL,
                meta: {
                    requiresAuth: true
                }
            },
            // Temperatur:
            {
                path: "qs/temperaturen",
                name: "temperaturen",
                component: Temperaturen,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/temperaturen/anlegen/:bereich",
                name: "temperatur-log",
                component: AddLog,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/temperaturen/:bereich",
                name: "temperatur-logs",
                component: TempLogs,
                meta: {
                    requiresAuth: true
                }
            },
            // --- QS Checklisten: ---
            {
                path: "qs/servicelisten/checklists",
                name: "checklisten",
                component: DashboardCL,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/servicelisten/checklists/:bereichID",
                name: "Checklisten",
                component: DashboardRN,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/servicelisten/checklists/:bereichID/checklist/:id",
                name: "checkliste",
                component: ChecklistRN,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/servicelisten/checklists/:bereichID/checklist/add/:bereichID",
                name: "checkliste hinzufügen",
                component: AddChecklistRN,
                meta: {
                    requiresAuth: true
                }
            },
            // --- Heisse Theke: ---
            {
                path: "qs/servicelisten/heissetheke",
                name: "heisse theke",
                component: HTBereich,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/servicelisten/heissetheke/add",
                name: "Log hinzufügen",
                component: AddHTTempLog,
                meta: {
                    requiresAuth: true
                }
            },
            // --- Orgainvent: ---
            {
                path: "qs/servicelisten/orgainvent",
                name: "orgainvent",
                component: DashboardOI,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/servicelisten/orgainvent/add",
                name: "orgainvent",
                component: AddOrgainvent,
                meta: {
                    requiresAuth: true
                }
            },
            // --- Wareneingang: ---
            {
                path: "qs/servicelisten/wareneingang/temperatur",
                name: "wareneingang",
                component: WEBereich,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "qs/servicelisten/wareneingang/temperatur/add",
                name: "Log hinzufügen",
                component: AddWETempLog,
                meta: {
                    requiresAuth: true
                }
            },
            // ---------------------------
            // ---------------------------
            // ---------------------------
            {
                path: "kunden",
                name: "termine",
                component: Kunden,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "umsätze",
                name: "umsätze",
                component: Umsätze,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "tagestour",
                name: "tagestour",
                component: Tagestour,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "kalender",
                name: "kalender",
                component: Kalender,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "addblocker",
                name: "addblocker",
                component: Addblocker,
                meta: {
                    requiresAuth: true
                }
            },

            {
                path: "packliste",
                name: "packliste",
                component: Packliste,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "googlemap",
                name: "googlemap",
                component: GoogleMap,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "informationen",
                name: "informationen",
                component: Informationen,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "information/:kundennr",
                name: "information",
                component: Information,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "login",
                name: "login",
                component: Login,
                meta: {
                    requiresGuest: true
                }
            },
            {
                path: "pfand/:kundennr",
                name: "pfandrückgabe",
                component: Pfandrückgabe,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "waren/:kundennr",
                name: "warenrücknahme",
                component: Warenrücknahme,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "bestellung/:bestellnr",
                name: "Details",
                component: Bestellungsdetails,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "addbestellung/:kundennr",
                name: "AddBestellung",
                component: AddBestellung,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "editbestellung/:bestellnr",
                name: "EditBestellung",
                component: EditBestellung,
                meta: {
                    requiresAuth: true
                }
            }
            // {
            //   path: "research/:id&:limit",
            //   name: "research",
            //   component: Research,
            //   meta: {
            //     requiresAuth: true
            //   }
            // }
        ]
    },
    { path: "*", component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
